import React, {FunctionComponent} from "react";
import {makeStyles} from "tss-react/mui";
import {Button, Dialog, DialogActions, DialogContent, Theme, Typography,} from "@mui/material";
import MuiDialogTitle from "@mui/material/DialogTitle";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";
import {VpnKey} from "@mui/icons-material";
import {useHistory} from "react-router-dom";

interface IPreviousContractNotCheckedInModal {
    open: boolean;
    handleClose: () => void;
    bookingId: string;
    type: string;
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },

    submit: {
        margin: theme.spacing(3, 0, 2),
    },

    buttonProgress: {
        position: "absolute",
        top: "54%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },

    wrapper: {
        margin: theme.spacing(0),
        marginTop: theme.spacing(2),
        position: "relative",
    },
}));

const PreviousContractNotCheckedInModal: FunctionComponent<
    IPreviousContractNotCheckedInModal
> = ({open, handleClose, bookingId, type}): JSX.Element => {
    const {classes} = useStyles();
    const {t} = useTranslation();
    const history = useHistory();

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            maxWidth={"xs"}
        >
            <MuiDialogTitle className={classes.root}>
                <Typography variant="h6">{t("general.lastBookingNotCheckedIn")}</Typography>
            </MuiDialogTitle>
            <DialogContent style={{textAlign: "center"}}>
                <ReportProblemOutlinedIcon
                    style={{fontSize: 100, color: "red"}}
                />
                <Typography gutterBottom>
                    {t("general.lastBookingNotCheckedInText")}
                </Typography>
            </DialogContent>
            <DialogActions>
                <div className={classes.wrapper}>
                    <Button
                        onClick={() => {
                            if (type == "contract_co") {
                                history.push(`/manager/contract/${bookingId}/ci`);
                            } else {
                                history.push(`/manager/transfer/${bookingId}/ci`);
                            }
                        }}
                        startIcon={<VpnKey/>}
                        size={"small"}
                        color="primary"
                        variant={"outlined"}
                        className={classes.submit}
                    >
                        Check In
                    </Button>
                </div>
                <div className={classes.wrapper}>
                    <Button
                        onClick={handleClose}
                        size={"small"}
                        color="secondary"
                        variant={"outlined"}
                        className={classes.submit}
                    >
                        {t("general.cancel")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default PreviousContractNotCheckedInModal;
